import actions from 'state/constants';

export const activateExperiment = (experimentName, options) => dispatch => {
  dispatch({
    type: actions.ACTIVATE_EXPERIMENT,
    payload: { experimentIdentifier: experimentName, options },
  });
};

export default activateExperiment;
